import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import List from 'apollo-react/components/List';
import ListItem from 'apollo-react/components/ListItem';
import ListItemIcon from 'apollo-react/components/ListItemIcon';
import ListItemText from 'apollo-react/components/ListItemText';
import React, { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDispatch, useSelector } from 'react-redux';

import DashboardDialog from './DashboardDialog';
import { handleRequestCancel, saveDashboardConfig } from '../../../actions/DashboardConfigActions';
import imgBar from '../../../assets/images/dialog-bar.png';
import imgDonut from '../../../assets/images/dialog-blue.png';
import imgEmbedded from '../../../assets/images/dialog-http.png';
import imgTable from '../../../assets/images/dialog-list.png';
import imgBigTable from '../../../assets/images/dialog-table.png';
import DndContainer from '../../../components/DndContainer';
import withTranslation from '../../../components/withTranslation';
import { getDashboardConfig } from '../../../selectors/DashboardSelectors';
import * as selectors from '../../../selectors/DashboardSelectors';

const useStyles = makeStyles({
  root: {},
  leftContent: {
    maxWidth: '220px',
  },
  listItem: {
    paddingLeft: '0px',
  },
  centerContent: {
    maxWidth: '500px',
    paddingRight: '100px',
    paddingLeft: '10px',
  },
  rightContent: {
    paddingRight: '10px',
  },
  visualimage: {
    maxWidth: '120px',
  },
});

const EditDashboardPartsDialog = ({ open, translateString }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { actorCode } = useSelector((state) => state.auth);
  const dashboardParts = useSelector(selectors.getParts);
  const { userSpecificDashboard, isEditGlobal, hasAdminRights, code: dashboardCode } = useSelector(
    getDashboardConfig
  );
  const [parts, setParts] = useState([]);
  const [config, setConfig] = useState({});

  useEffect(() => {
    setParts(dashboardParts);
  }, [dashboardParts]);

  useEffect(() => {
    const config = parts.reduce((acc, part) => ({ ...acc, [part.id]: part }), {});
    setConfig(config);
  }, [parts]);

  const toogleVisibility = (id) => {
    setParts(parts.map((part) => (part.id !== id ? part : { ...part, hidden: !part.hidden })));
  };

  const swapItems = (index1, index2, list) => {
    const newList = [...list];

    [newList[index1], newList[index2]] = [newList[index2], newList[index1]];

    return newList;
  };

  const movePart = (dragIndex, hoverIndex) => {
    setParts(swapItems(dragIndex, hoverIndex, parts));
  };

  const getVisualizationImg = (vis) => {
    switch (vis) {
      case 'donut':
        return <img alt="" className={classes.visualimage} src={imgDonut} />;
      case 'bar':
        return <img alt="" className={classes.visualimage} src={imgBar} />;
      case 'table':
        return <img alt="" className={classes.visualimage} src={imgTable} />;
      case 'bigtable':
        return <img alt="" className={classes.visualimage} src={imgBigTable} />;
      case 'embedded':
        return <img alt="" className={classes.visualimage} src={imgEmbedded} />;
      default:
        return 'Img Missing';
    }
  };

  const getIsActionEnabled = (deletable, name) => {
    return deletable || (name === 'My Training Tasks' && isEditGlobal);
  };

  const handleClose = () => {
    dispatch(
      handleRequestCancel({
        action: 'general',
        userSpecificDashboard,
        dashboardCode,
        actorCode,
        hasAdminRights,
        isEditGlobal,
      })
    );
  };

  const cancelButton = {
    onClick: handleClose,
    label: translateString('Cancel'),
  };

  const save = {
    label: translateString('Accept'),
    onClick: () =>
      dispatch(
        saveDashboardConfig({
          updates: config,
          isEditGlobal,
        })
      ),
  };

  return (
    <DashboardDialog onClose={handleClose} open={open} buttonProps={[cancelButton, save]}>
      <List>
        <DndProvider backend={HTML5Backend}>
          {parts.map((part, index) => {
            const { id, name, description, tabs, deletable, hidden } = part;
            return (
              <DndContainer key={id} id={id} index={index} moveItem={movePart}>
                <ListItem>
                  <ListItemIcon>{getVisualizationImg(tabs[0].visualization)}</ListItemIcon>
                  <ListItemText
                    primary={translateString(name)}
                    secondary={translateString(description)}
                    className={classes.centerContent}
                  />
                  {getIsActionEnabled(deletable, name) && (
                    <ListItemSecondaryAction className={classes.rightContent}>
                      {hidden ? (
                        <Button
                          onClick={() => toogleVisibility(id)}
                          edge="end"
                          color="secondary"
                          variant="secondary"
                        >
                          {translateString('Add')}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => toogleVisibility(id)}
                          edge="end"
                          color="secondary"
                          variant="secondary"
                        >
                          {translateString('Delete')}
                        </Button>
                      )}
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              </DndContainer>
            );
          })}
        </DndProvider>
      </List>
    </DashboardDialog>
  );
};

export default withTranslation(EditDashboardPartsDialog);
